import { useState } from "react";
import { useCreateProductServicePublicAxiosInstance } from "../../Auth/useCreateProductServicePublicAxiosInstance.ts";
import { CreateBonificoDraftPayload } from "./BonificoOrderDTO.ts";

export function useCreateBonificoDraft() {
  const { createAxiosInstance } = useCreateProductServicePublicAxiosInstance();
  const [loading, setLoading] = useState(false);

  const createDraft = async (
    payload: CreateBonificoDraftPayload,
  ): Promise<{ orderId: string }> => {
    setLoading(true);
    try {
      const { data } = await createAxiosInstance().post<{ orderId: string }>(
        "/bonifico-orders/drafts",
        payload,
      );
      return data;
    } finally {
      setLoading(false);
    }
  };

  return { createDraft, loading };
}
